export default __webpack_public_path__ + "static/media/gallery - story - pot (1)_00.525ef2da.jpg";